<template>
  <div>
    <main-layout>
      <div>
        <div v-if="currentView == 'list'">
          <v-container>
            <h3 class="headline">{{ $t('Draft') }}</h3>
            <template v-if="loading">
              <div class="text-xs-center" style="padding: 10px 0px">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="35px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <template v-else>
              <div class="broadcasts">
                <div style="margin-bottom: 15px;">
                  <a
                    href="javascript:void(0);"
                    @click="
                      selected_edit_broadcast = undefined
                      currentView = 'edit'
                    "
                    style="text-decoration: none"
                  >
                    <div class="add-broadcast text-xs-center">
                      <i class="fa fa-plus middle"></i>
                      {{ $t('Add new broadcast') }}
                    </div>
                  </a>
                </div>

                <template v-if="draft_broadcasts && draft_broadcasts.length > 0">
                  <div
                    class="broadcast mb-3"
                    v-for="(broadcast, index) in draft_broadcasts"
                    :key="'draft_broadcast_' + index"
                  >
                    <v-layout wrap>
                      <v-flex xs12 sm8>
                        <p class="text-truncate">{{ broadcast.name }}</p>
                      </v-flex>
                      <v-flex xs12 sm4 text-xs-right>
                        <v-btn
                          fab
                          outline
                          class="extra-small ma-1"
                          color="primary"
                          @click="editBroadcast(index)"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </v-btn>
                        <v-btn
                          fab
                          outline
                          class="extra-small ma-1"
                          color="primary"
                          @click="copyBroadcast(index, 'draft')"
                        >
                          <i class="fas fa-copy"></i>
                        </v-btn>
                        <v-btn
                          fab
                          outline
                          class="extra-small ma-1"
                          color="primary"
                          @click="deleteBroadcast(broadcast.id, broadcast.name)"
                        >
                          <i class="fas fa-trash"></i>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm4 class="grey--text text--lighten-1 caption">{{
                        broadcast.createdtime | DateFormat('DD/MM/YYYY hh:mm A')
                      }}</v-flex>
                      <v-flex xs12 sm8 class="text-xs-left text-sm-right">
                        <v-chip
                          color="info"
                          text-color="white"
                          small
                          disabled
                          v-if="broadcast.isschedule"
                        >
                          <v-avatar>
                            <v-icon>access_time</v-icon>
                          </v-avatar>
                          {{ broadcast.scheduletime | dateFormat('DD/MM/YYYY hh:mm A') }}
                        </v-chip>
                        <v-chip
                          color="#A0E83D"
                          text-color="white"
                          small
                          disabled
                          v-if="broadcast.status == 'sent'"
                          >{{ $t('Broadcasted') }}</v-chip
                        >
                        <v-chip color="grey" text-color="white" small disabled v-else>{{
                          $t('Draft')
                        }}</v-chip>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
              </div>
            </template>
            <br />

            <h3 class="headline">{{ $t('Broadcasted') }}</h3>

            <template v-if="loading">
              <div class="text-xs-center" style="padding: 10px 0px">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="35px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <template v-else>
              <div class="broadcasts">
                <template v-if="sent_broadcasts && sent_broadcasts.length > 0">
                  <div
                    class="broadcast mb-3"
                    v-for="(broadcast, index) in sent_broadcasts"
                    :key="'sent_broadcast_' + index"
                  >
                    <v-layout wrap>
                      <v-flex xs12 sm8>
                        <p class="text-truncate">{{ broadcast.name }}</p>
                      </v-flex>
                      <v-flex xs12 sm4 text-xs-right>
                        <v-btn
                          fab
                          outline
                          class="extra-small ma-1"
                          color="primary"
                          @click="copyBroadcast(index, 'sent')"
                        >
                          <i class="fas fa-copy"></i>
                        </v-btn>
                        <v-btn
                          fab
                          outline
                          class="extra-small ma-1"
                          color="primary"
                          @click="viewBroadcast(index)"
                        >
                          <i class="fas fa-eye"></i>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm4 class="grey--text text--lighten-1 caption">{{
                        broadcast.createdtime | DateFormat('DD/MM/YYYY hh:mm A')
                      }}</v-flex>
                      <v-flex xs12 sm8 class="text-xs-left text-sm-right">
                        <v-chip
                          color="info"
                          text-color="white"
                          small
                          disabled
                          v-if="broadcast.isschedule"
                        >
                          <v-avatar>
                            <v-icon>access_time</v-icon>
                          </v-avatar>
                          {{ broadcast.scheduletime | dateFormat('DD/MM/YYYY hh:mm A') }}
                        </v-chip>
                        <v-chip color="#A0E83D" text-color="white" small disabled>{{
                          $t('Broadcasted')
                        }}</v-chip>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
                <template v-else>
                  <p class="no-broadcast text-xs-center">{{ $t('No Sent broadcast') }}</p>
                </template>
              </div>
            </template>
          </v-container>
          <div class="mt-5 mb-5"></div>
        </div>
        <div v-if="currentView == 'edit'">
          <template v-if="currentView == 'edit'">
            <broadcast-manage
              @onClose="onClose"
              :value="selected_edit_broadcast"
              @onSave="onSave"
            ></broadcast-manage>
          </template>
        </div>
        <div v-if="currentView == 'view'">
          <template v-if="selected_view_broadcast">
            <broadcast-view @onClose="onClose" :value="selected_view_broadcast"></broadcast-view>
          </template>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import BroadcastManage from './BroadcastManage'
import BroadcastView from './BroadcastView'
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'

export default {
  data: function() {
    return {
      copy_name: '',
      sent_name: '',
      isSave: false,
      isCopy: false,
      currentView: 'list',
      isFail: false,
      draft_broadcasts: [],
      sent_broadcasts: [],
      selected_edit_broadcast: undefined,
      selected_view_broadcast: undefined,
      loading: true
    }
  },
  components: {
    BroadcastManage,
    BroadcastView,
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    var vm = this
    if (vm.selectedBot.theme == 'ecommercebasic') {
      vm.$store.dispatch('loadCategory').then(function() {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
    vm.loading = true
    vm.getBroadcast(function() {
      vm.loading = false
    })
    vm.$store.dispatch('loadStatus')
  },
  methods: {
    onClose: function(payload) {
      var vm = this
      vm.currentView = 'list'
      vm.loading = true
      if (payload) {
      }
      vm.getBroadcast(function() {
        vm.loading = false
      })
    },
    getBroadcast: function(callback) {
      var vm = this
      api.getBroadcast(vm.selectedBot.pageid, function(error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (response.data.length > 0) {
          vm.draft_broadcasts = []
          vm.sent_broadcasts = []
          $.each(response.data, function(index, broadcast) {
            if (broadcast.status === 'draft') {
              vm.draft_broadcasts.push(broadcast)
            } else if (
              broadcast.isschedule &&
              broadcast.status === 'sent' &&
              broadcast.senttime == null
            ) {
              vm.draft_broadcasts.push(broadcast)
            } else {
              vm.sent_broadcasts.push(broadcast)
            }
          })
        }
        callback()
      })
    },
    editBroadcast: function(index) {
      this.selected_edit_broadcast = this.draft_broadcasts[index]
      this.currentView = 'edit'
    },
    viewBroadcast: function(index) {
      var vm = this
      this.selected_view_broadcast = this.sent_broadcasts[index]
      vm.$nextTick(function() {
        vm.currentView = 'view'
      })
    },
    deleteBroadcast: function(broadcastid, broadcastname) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: broadcastname.replace(/\<|\>/g, '')
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            api.deleteBroadcast(
              { pageid: vm.selectedBot.pageid, broadcastid: broadcastid },
              function(error, response) {
                if (error) {
                  console.error(error)
                  // vm.loading = true
                  return
                }

                $.each(vm.draft_broadcasts, function(index, broadcast) {
                  if (broadcast.id == broadcastid) {
                    vm.draft_broadcasts.splice(index, 1)
                    return false
                  }
                })
              }
            )
          }
        })
    },
    onSave: function(payload) {
      var vm = this
      vm.saveBroadcast(payload.data, function(status, id) {
        payload.onSave(status, id)
      })
    },
    copyBroadcast: function(index, type) {
      var vm = this
      var data
      if (type === 'draft') {
        data = Object.assign({}, vm.draft_broadcasts[index])
      } else if (type === 'sent') {
        data = Object.assign({}, vm.sent_broadcasts[index])
      }

      vm.$swal
        .fire({
          title: vm.$t('Do you want to copy {name}?', { name: data.name.replace(/\<|\>/g, '') }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            data.id = null
            data.name += ' copy'
            ;(data.sendflag = false),
              (data.page_access_token = vm.selectedBot.page_access_token),
              (vm.copy_name = data.name)
            vm.saveBroadcast(data, function(status, id) {
              if (status) {
                data.id = id
                vm.draft_broadcasts.unshift(data)
                vm.$swal.fire({
                  title: vm.$t('Broadcast {copy_name} copy', {
                    copy_name: data.name.replace(/\<|\>/g, '')
                  }),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
              }
            })
          }
        })
    },
    saveBroadcast: function(data, callback) {
      api.updateBroadcast(data, function(error, response) {
        if (error) {
          console.error(error)
          callback(false, null)
          return
        }
        var id = null
        if (response.broadcastid) {
          id = response.broadcastid
        }
        callback(true, id)
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/Broadcast.vue